
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/zacatek-lyzarske-sezony-predpoklad",
      function () {
        return require("private-next-pages/[region]/zacatek-lyzarske-sezony-predpoklad.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/zacatek-lyzarske-sezony-predpoklad"])
      });
    }
  